import { useCallback, useMemo } from 'react';
import { useSettings } from '@wu/widget-core';
import { actions } from './actions';
import StyledWidgetButton from './StyledWidgetButton';

export default function Button() {
  const {
    editMode,
    buttonTextColor,
    buttonCornerRadius,
    buttonLabelFont,
    shadow,
    buttonTextColorOnHover,
    buttonColorOnHover,
    action,
    link,
    verticalPadding,
    horizontalPadding,
    buttonType,
    buttonFilledColor,
    buttonOutlineColor,
    openInNewTab,
    email,
    call,
    sendSMS,
    callSkype,
    chatWhatsapp,
    chatTelegram,
    chatSkype,
    followFacebook,
    followInstagram,
    followLinkedIn,
    followPinterest,
    followTikTok,
    followX,
    followYoutube,
    shareFacebook,
    shareLinkedIn,
    shareX,
    sharePinterest,
    position,
    scrollToElement
  } = useSettings();

  const onClick = useCallback(
    (e, link) => {
      const actionsValues = {
        email,
        call,
        sendSMS,
        callSkype,
        chatWhatsapp,
        chatTelegram,
        chatSkype,
        followFacebook,
        followInstagram,
        followLinkedIn,
        followPinterest,
        followTikTok,
        followX,
        followYoutube,
        shareFacebook,
        shareLinkedIn,
        shareX,
        sharePinterest,
        scrollToElement
      };

      if (action === 'linkToPage') {
        const url = link.includes('http') ? link : `https://${link}`;

        if (editMode || openInNewTab) {
          return actions.openInNewTab(e, url);
        }
        return actions.redirect(e, url);
      } else {
        actions[action](e, action !== 'print' && actionsValues[action]);
      }
    },
    [
      editMode,
      action,
      call,
      callSkype,
      chatSkype,
      chatTelegram,
      chatWhatsapp,
      email,
      followFacebook,
      followInstagram,
      followLinkedIn,
      followPinterest,
      followTikTok,
      followX,
      followYoutube,
      openInNewTab,
      sendSMS,
      shareFacebook,
      shareLinkedIn,
      sharePinterest,
      shareX,
      scrollToElement
    ]
  );

  const buttonProps = useMemo(
    () => ({
      fontSize: buttonLabelFont?.fontSize,
      color: buttonType === 'outline' ? buttonOutlineColor : buttonFilledColor,
      fontColor:
        buttonType === 'outline' ? buttonOutlineColor : buttonTextColor,
      mode: buttonType === 'outline' ? buttonType : 'contain',
      borderRadius: buttonCornerRadius,
      borderColor: buttonOutlineColor,
      withShadow: shadow,
      onClick: (e) =>
        onClick(e, link.includes('http') ? link : `https://${link}`),
      padding: [verticalPadding, horizontalPadding],
      verticalPadding,
      horizontalPadding,
      position,
      iconOnly: false,
      fontWeight:
        buttonType === 'outline' ? buttonLabelFont.fontWeight : 'normal'
    }),
    [
      buttonLabelFont?.fontSize,
      buttonLabelFont.fontWeight,
      buttonType,
      buttonOutlineColor,
      buttonFilledColor,
      buttonTextColor,
      buttonCornerRadius,
      shadow,
      verticalPadding,
      horizontalPadding,
      buttonTextColorOnHover,
      buttonColorOnHover,
      position,
      onClick,
      link
    ]
  );

  const renderButton = useCallback(() => {
    return <StyledWidgetButton {...buttonProps} />;
  }, [buttonProps]);

  return renderButton();
}
